<div class="main-content table-page table-page--compact tickets-depurados-page" *ngIf="formulario.mostrarFrmControl">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Gestión de Tickets Depurados</h1>
        <p>Filtre tickets por área y criterios específicos para revisar rápidamente los registros depurados.</p>
      </div>
    </section>

    <section class="table-page__card">
      <form [formGroup]="options">
        <div class="table-page__toolbar table-page__toolbar--filters">
          <div class="table-page__filters-grid">
            <div class="table-page__filter table-page__filter--medium">
              <mat-form-field appearance="outline" class="table-page__field">
                <mat-label>Área</mat-label>
                <mat-select formControlName="areaCtrl" (selectionChange)="onAreaChange($event.value)">
                  <mat-option *ngFor="let item of areas" [value]="item">
                    {{ item.area }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="table-page__filter table-page__filter--medium">
              <mat-form-field appearance="outline" class="table-page__field">
                <mat-label>Seleccionar filtros</mat-label>
                <mat-select formControlName="filtrosCtrl" (selectionChange)="mostrarOcultarFitros()" multiple>
                  <mat-option *ngFor="let filtro of filtros" [value]="filtro">
                    {{ filtro }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="table-page__filter table-page__filter--wide" *ngIf="filtroDto.nombre">
              <mat-form-field appearance="outline" class="table-page__field">
                <mat-label>Nombre corto</mat-label>
                <input matInput aria-label="Nombre corto" formControlName="asuntoCtrl" (input)="onAsuntoChange($any($event.target).value)" />
              </mat-form-field>
            </div>

            <div class="table-page__filter table-page__filter--medium" *ngIf="filtroDto.fecha">
              <mat-form-field appearance="outline" class="table-page__field">
                <mat-label>Fecha</mat-label>
                <input matInput aria-label="Fecha" [matDatepicker]="picker1" formControlName="dateCtrl" (dateChange)="onDateChange()" readonly />
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
            </div>
          </div>

          <div class="table-page__toolbar-actions">
            <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="clear()">
              <i class="material-icons">close</i>
              <span>Limpiar</span>
            </button>
            <button type="button" mat-raised-button class="btn table-page__icon-btn" (click)="consultaTicketsDepurados()">
              <i class="material-icons">search</i>
              <span>Buscar</span>
            </button>
          </div>
        </div>
      </form>

      <div class="table-page__table-wrap">
        <table class="table-page__table" *ngIf="ticketsDepurados.length > 0; else ticketsDepuradosState">
          <thead>
            <tr>
              <th>Título</th>
              <th>Fecha creación</th>
              <th>Estatus</th>
              <th class="table-page__actions-head">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ticket of ticketsDepurados">
              <td>
                <div class="table-page__cell-stack">
                  <strong class="table-page__name">{{ ticket.asunto || 'Sin asunto' }}</strong>
                  <span class="table-page__subtext">Área: {{ areaSeleccionada?.area || 'Sin área' }}</span>
                </div>
              </td>
              <td>
                <span class="table-page__text">{{ ticket.fechaSolicitud | date: 'dd/MM/yyyy' }}</span>
              </td>
              <td>
                <span class="table-page__status-badge" [ngClass]="getStatusClass(ticket)">
                  {{ getStatusLabel(ticket) }}
                </span>
              </td>
              <td class="table-page__actions">
                <button type="button" class="table-page__action-btn" (click)="verDetalleTicket(ticket)">
                  <i class="material-icons">visibility</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <ng-template #ticketsDepuradosState>
          <div class="table-page__empty table-page__empty--loading" *ngIf="loading; else ticketsDepuradosFallback">
            <i class="material-icons">hourglass_top</i>
            <strong>Cargando tickets depurados...</strong>
          </div>
        </ng-template>

        <ng-template #ticketsDepuradosFallback>
          <div class="table-page__empty" *ngIf="consultaRealizada; else ticketsDepuradosInitialState">
            <i class="material-icons">inbox</i>
            <strong>No se encontraron tickets</strong>
            <span>Pruebe con otro conjunto de filtros o cambie el área seleccionada.</span>
          </div>
        </ng-template>

        <ng-template #ticketsDepuradosInitialState>
          <div class="table-page__empty">
            <i class="material-icons">manage_search</i>
            <strong>Configure los filtros para consultar tickets</strong>
            <span>Seleccione un área y aplique los filtros necesarios antes de ejecutar la búsqueda.</span>
          </div>
        </ng-template>
      </div>

      <div class="table-page__footer" *ngIf="showPagination">
        <div class="table-page__meta">
          <span>Mostrando {{ rangeEnd }} de {{ totalItems }} tickets</span>
          <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

          <label class="table-page__page-size">
            <span>Ver:</span>
            <select [ngModel]="itemsPerPage" (ngModelChange)="onPageSizeChange($event)">
              <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
            </select>
          </label>
        </div>

        <div class="table-page__pager" *ngIf="totalPages > 0">
          <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
            Inicio
          </button>
          <button type="button" class="table-page__pager-link" (click)="previousPage()" [disabled]="currentPage === 1">
            Anterior
          </button>

          <ng-container *ngFor="let item of getPaginationItems()">
            <button
              *ngIf="isPageNumber(item); else ticketsDepuradosPagerEllipsis"
              type="button"
              class="table-page__pager-page"
              [class.is-current]="item === currentPage"
              (click)="onPageChange(item)">
              {{ item }}
            </button>

            <ng-template #ticketsDepuradosPagerEllipsis>
              <span class="table-page__pager-ellipsis">...</span>
            </ng-template>
          </ng-container>

          <button type="button" class="table-page__pager-link" (click)="nextPage()" [disabled]="currentPage === totalPages">
            Siguiente
          </button>
          <button type="button" class="table-page__pager-link" (click)="lastPage()" [disabled]="currentPage === totalPages">
            Último
          </button>
        </div>
      </div>
    </section>
  </div>
</div>

<div class="main-content">
  <app-detalle-cte-ticket
    *ngIf="formulario.mostrarFrmDetalle"
    [ticket]="ticketSeleccionado"
    (regresarAPrincipal)="invertirVistas(true)"
    (mostrarMascara)="mostrarMascara($event)">
  </app-detalle-cte-ticket>
</div>
